module.exports = __webpack_public_path__ + "2e8bc0145776e1c7d17be60fe6443280.fbx";